import { render, staticRenderFns } from "./UserDetails_Text_Small.vue?vue&type=template&id=369d4434&"
import script from "./UserDetails_Text_Small.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Text_Small.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Text_Small.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports